// Tiny toast with optional inline action. Two shapes:
//   <Toast msg="Saved" />                                      — plain
//   <Toast msg="Skipped 2 in pantry" action={{ label: "Add anyway", onClick: () => ... }} />
//
// The action button stays visible for the toast's lifetime; clicking
// it should trigger the override path AND dismiss the toast (parent
// owns the lifetime, so it can clear msg on action.onClick).

import { Icon } from "../icons";

export interface ToastAction {
  label: string;
  onClick: () => void;
}

/** Signature for the app-level notify callback. Components that need
 *  to surface an actionable toast (e.g. "Add anyway" override, or an
 *  undo affordance) take this type instead of the narrower
 *  `(msg: string) => void`; the wider sig is structurally assignable
 *  from the existing `notify` reference in app.tsx. */
export type NotifyFn = (
  msg: string,
  opts?: { action?: ToastAction },
) => void;

export function Toast({ msg, action }: { msg: string | null; action?: ToastAction }) {
  if (!msg) return null;
  return (
    <div className="toast-wrap">
      <div className="toast">
        <Icon name="check" size={14} />
        <span>{msg}</span>
        {action && (
          <button
            type="button"
            className="toast-action"
            onClick={action.onClick}
          >
            {action.label}
          </button>
        )}
      </div>
    </div>
  );
}
